import { render, staticRenderFns } from "./Profesionales-independientes-y-pymes.vue?vue&type=template&id=316360f7&scoped=true&"
import script from "./Profesionales-independientes-y-pymes.vue?vue&type=script&lang=js&"
export * from "./Profesionales-independientes-y-pymes.vue?vue&type=script&lang=js&"
import style0 from "./Profesionales-independientes-y-pymes.vue?vue&type=style&index=0&id=316360f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316360f7",
  null
  
)

export default component.exports